module.exports = __webpack_public_path__ + "static/img/日本.2df446a1.png";